import { render, staticRenderFns } from "./MyChats.vue?vue&type=template&id=2596d031&"
import script from "./MyChats.vue?vue&type=script&lang=js&"
export * from "./MyChats.vue?vue&type=script&lang=js&"
import style0 from "./MyChats.vue?vue&type=style&index=0&id=2596d031&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports